import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';

// patchAngularStylesWithNonce(); 
platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

// function patchAngularStylesWithNonce() {
//   const nonce = document.querySelector('meta[name="csp-nonce"]')?.getAttribute('content');
//   if (!nonce) return;

//   const originalAppendChild = document.head.appendChild;
//   const originalInsertBefore = document.head.insertBefore;

//   const addNonceIfStyle = (node: any) => {
//     if (node && node.tagName === 'STYLE' && !node.hasAttribute('nonce')) {
//       node.setAttribute('nonce', nonce);
//     }
//     return node;
//   };

//   // Patch both appendChild and insertBefore (Angular uses either)
//   document.head.appendChild = function (node) {
//     return originalAppendChild.call(this, addNonceIfStyle(node));
//   };

//   document.head.insertBefore = function (newNode, referenceNode) {
//     return originalInsertBefore.call(this, addNonceIfStyle(newNode), referenceNode);
//   };
// }